import * as React from 'react';

const Footer: React.FC = () => {

  const currentYear = new Date().getFullYear();
  return (
    <div className='flex flex-col items-center justify-center w-full text-sm text-white bg-[#333215] py-8'>
      <p className='px-4'>
        <span>&copy; {currentYear}&nbsp;</span>
        <strong>CheQRboard</strong>
      </p>
      <p className='px-4 text-center'>
        <strong>CheQRboard</strong>
        <span>
          &nbsp;is The Ultimate Content Management and Analytics Platform for
          Venues.
        </span>
      </p>
      <p className='px-4 text-center'>
        <span>
          &nbsp;
          132 Citaiton Ln., Smithfield, NC 27577
        </span>
      </p>

      <p>
      &nbsp;
      </p>

      <div className='flex'>
        <p>
          Privacy Policy | &nbsp;
        </p>
        <p>
          Terms of Use | &nbsp;
        </p>
        <p>
          Accessibility Policy
        </p>
      </div>
    </div>
  );
};

export default Footer;